import PlayAudio from './PlayAudio'

export { PlayAudio }
